<template>
  <header>
  <div class="header-left">
    <router-link :to="{ path: '/' }" class="logo" data-cursor-hover data-cursor-mix-blend-mode="difference">
      <img src="../assets/images/logo.svg" alt="" width="128" />
    </router-link>
  </div>
  <div class="header-right">
  </div>
  </header>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'Header',
  methods: {
  }
}
</script>

<style lang='scss'>

header {
  float: left;
  width: 100%;
  padding: 50px !important;
  position: fixed;
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  z-index: 4;
  a {
    color: #56320e;
    &:hover {
      color: #56320e;
    }
    &.logo:after {
      display: none;
    }
    &:after {
      background: #56320e;
    }
  }
  .team-page{
    a{
      color:#f4eeb4;
    }
  }
  .header{
    &-hide{
      display:none;
    }
    &-show{
      display:block;
      a{
        color:#f4eeb4;
        &:after{
          background:#f4eeb4;
        }
      }
    }
  }
}
.hamburger {
  padding: 15px;
  display: inline-block;
  cursor: pointer;
  transition-property: opacity, filter;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  font: inherit;
  color: inherit;
  text-transform: none;
  background-color: transparent;
  border: 0;
  margin: 0 0 0 60px;
  overflow: visible;
  vertical-align: middle;
  &:hover {
    opacity: 0.7;
  }
  &.is-active {
    &:hover {
      opacity: 0.7;
    }
    .hamburger-inner {
      background-color: #425454;
      &::before, &::after {
        background-color: #425454;
      }
    }
  }
}
.hamburger-box {
  width: 40px;
  height: 24px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
}
.hamburger-inner {
  display: block;
  top: 50%;
  margin-top: -2px;
  width: 40px;
  height: 4px;
  background-color: #f4eeb4;
  position: absolute;
  transition-property: transform;
  transition-duration: 0.15s;
  transition-timing-function: ease;
  &::before, &::after {
    width: 40px;
    height: 4px;
    background-color: #f4eeb4;
    position: absolute;
    transition-property: transform;
    transition-duration: 0.15s;
    transition-timing-function: ease;
  }
  &::before, &::after {
    content: "";
    display: block;
  }
  &::before {
    top: -10px;
  }
  &::after {
    bottom: -10px;
  }
}
.hamburger--emphatic {
  overflow: hidden;
  .hamburger-inner {
    transition: background-color 0.125s 0.175s ease-in;
    &::before {
      left: 0;
      transition: transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335), top 0.05s 0.125s linear, left 0.125s 0.175s ease-in;
    }
    &::after {
      top: 10px;
      right: 0;
      transition: transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335), top 0.05s 0.125s linear, right 0.125s 0.175s ease-in;
    }
  }
  &.is-active .hamburger-inner {
    transition-delay: 0s;
    transition-timing-function: ease-out;
    background-color: transparent !important;
    &::before {
      left: -80px;
      top: -80px;
      transform: translate3d(80px, 80px, 0) rotate(45deg);
      transition: left 0.125s ease-out, top 0.05s 0.125s linear, transform 0.125s 0.175s cubic-bezier(0.075, 0.82, 0.165, 1);
    }
    &::after {
      right: -80px;
      top: -80px;
      transform: translate3d(-80px, 80px, 0) rotate(-45deg);
      transition: right 0.125s ease-out, top 0.05s 0.125s linear, transform 0.125s 0.175s cubic-bezier(0.075, 0.82, 0.165, 1);
    }
  }
}

.hamburger2 {
  padding: 15px;
  display: inline-block;
  cursor: pointer;
  transition-property: opacity, filter;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  font: inherit;
  color: inherit;
  text-transform: none;
  background-color: transparent;
  border: 0;
  margin: 0 0 0 60px;
  overflow: visible;
  vertical-align: middle;
  &:hover {
    opacity: 0.7;
  }
  &.is-active {
    &:hover {
      opacity: 0.7;
    }
    .hamburger2-inner {
      background-color: #f4eeb4;
      &::before, &::after {
        background-color: #f4eeb4;
      }
    }
  }
}
.hamburger2-box {
  width: 40px;
  height: 24px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
}
.hamburger2-inner {
  display: block;
  top: 50%;
  margin-top: -2px;
  width: 40px;
  height: 4px;
  background-color: #f4eeb4;
  position: absolute;
  transition-property: transform;
  transition-duration: 0.15s;
  transition-timing-function: ease;
  &::before, &::after {
    width: 40px;
    height: 4px;
    background-color: #f4eeb4;
    position: absolute;
    transition-property: transform;
    transition-duration: 0.15s;
    transition-timing-function: ease;
  }
  &::before, &::after {
    content: "";
    display: block;
  }
  &::before {
    top: -10px;
  }
  &::after {
    bottom: -10px;
  }
}
.hamburger2--emphatic {
  overflow: hidden;
  .hamburger2-inner {
    transition: background-color 0.125s 0.175s ease-in;
    &::before {
      left: 0;
      transition: transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335), top 0.05s 0.125s linear, left 0.125s 0.175s ease-in;
    }
    &::after {
      top: 10px;
      right: 0;
      transition: transform 0.125s cubic-bezier(0.6, 0.04, 0.98, 0.335), top 0.05s 0.125s linear, right 0.125s 0.175s ease-in;
    }
  }
  &.is-active .hamburger2-inner {
    transition-delay: 0s;
    transition-timing-function: ease-out;
    background-color: transparent !important;
    &::before {
      left: -80px;
      top: -80px;
      transform: translate3d(80px, 80px, 0) rotate(45deg);
      transition: left 0.125s ease-out, top 0.05s 0.125s linear, transform 0.125s 0.175s cubic-bezier(0.075, 0.82, 0.165, 1);
    }
    &::after {
      right: -80px;
      top: -80px;
      transform: translate3d(-80px, 80px, 0) rotate(-45deg);
      transition: right 0.125s ease-out, top 0.05s 0.125s linear, transform 0.125s 0.175s cubic-bezier(0.075, 0.82, 0.165, 1);
    }
  }
}
@media screen and (max-width: 1024px) {
  header{
    padding:25px 50px !important;
  }
}
@media screen and (max-width: 767px) {
  header {
    padding: 20px !important;
  }
  .hamburger,
  .hamburger2 {
    padding:5px 0;
    margin:0 0 0 25px;
  }
}

@media screen and (max-width: 480px) {
  header {
    .header{
      &-right{
        a{
          font-size:16px !important;
        }
      }
    }
  }
}
</style>
